import { render, staticRenderFns } from "./ComparisonBanner.vue?vue&type=template&id=0c342bdc&scoped=true&"
import script from "./ComparisonBanner.vue?vue&type=script&lang=js&"
export * from "./ComparisonBanner.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonBanner.vue?vue&type=style&index=0&id=0c342bdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c342bdc",
  null
  
)

export default component.exports